import { media } from '../styles/MediaQueries';
import { isBrowser } from './isBrowser';
var mediaQueryPhonablet = isBrowser ? window.matchMedia(media.phonablet) : undefined;
export var isMobile = function isMobile() {
  return mediaQueryPhonablet === null || mediaQueryPhonablet === void 0 ? void 0 : mediaQueryPhonablet.matches;
};
//# sourceMappingURL=isMobile.js.map